/**
 * File: GlobalContextProvider.tsx
 * Description: Component to manage global context based on authentication and navigation state
 * Author: System
 * Created: 2025-09-04
 * Last Modified: 2025-09-04
 */

import React from 'react';

import { useGlobalContext } from '../hooks/useGlobalContext';

interface GlobalContextProviderProps {
  children: React.ReactNode;
}

/**
 * GlobalContextProvider - Initializes and manages global context state
 * This component should be placed high in the component tree to ensure
 * context is always up to date with authentication and navigation state
 */
export const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({ children }) => {
  // This hook will automatically manage context based on auth and navigation
  useGlobalContext();
  
  // This component doesn't render anything visual, just manages context
  return <>{children}</>;
};
